// Facade <image> geometry shared by every fence-drawing surface. Fence art is
// pre-widened (<name>_wide.png): 3 extra panels x 393px baked onto each side, so
// it overhangs the 1510px canvas and stays wide enough when a deep bed's
// facadeTransform shrinks it. Houses keep exact-canvas art.

export const FENCE_WIDE_OVERHANG = 1179; // 3 panels x 393px, must match the baked asset

const CANVAS_W = 1510;
const CANVAS_H = 850;

// Returns { href, x, y, width, height } for the facade image, or null when
// nothing should render (no facade / 'none' / house without a size).
export function facadeImageProps(s3Base, facade, houseSize) {
  if (!facade || facade === 'none') return null;
  if (facade.startsWith('fence_')) {
    return {
      href: `${s3Base}/${facade}_wide.png`,
      x: -FENCE_WIDE_OVERHANG,
      y: 0,
      width: CANVAS_W + 2 * FENCE_WIDE_OVERHANG,
      height: CANVAS_H,
    };
  }
  if (!houseSize) return null;
  return {
    href: `${s3Base}/${facade}_${houseSize}.png`,
    x: 0,
    y: 0,
    width: CANVAS_W,
    height: CANVAS_H,
  };
}
